/**
 * Skymedic UK - B2B Functionality
 * Professional dashboard, bulk ordering, resource filtering, dual pricing.
 * Compatible with both legacy selectors and new section-based B2B system.
 */

(function () {
  'use strict';

  /* ========================================================================
   * UTILITY: Format money (pence to display string)
   * Uses Shopify's money format from the theme. Falls back to GBP.
   * ======================================================================== */

  var MONEY_FORMAT = window.Shopify && window.Shopify.money_format
    ? window.Shopify.money_format
    : '\u00a3{{amount}}';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.floor(cents / 100).toString();
    var amountWithCommas = amount.replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    var amountNoDecimalsWithCommas = amountNoDecimals.replace(/(\d)(?=(\d{3})+$)/g, '$1,');

    return MONEY_FORMAT
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithCommas.replace(',', '.'))
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amountWithCommas);
  }

  /* ========================================================================
   * BULK ORDER FORM
   * Works with both the new section (#bulk-order-form) and legacy (.skymedic-bulk-order)
   * ======================================================================== */

  function initBulkOrderForm() {
    var form = document.getElementById('bulk-order-form') || document.querySelector('.skymedic-bulk-order');
    if (!form) return;

    var rows = form.querySelectorAll('.bulk-order-row');
    var totalEl = document.getElementById('bulk-order-total') || form.querySelector('.bulk-total-price');
    var itemsEl = document.getElementById('bulk-order-items') || form.querySelector('.bulk-total-items');
    var addBtn = document.getElementById('bulk-add-to-cart') || form.querySelector('.bulk-add-all');
    var messageEl = document.getElementById('bulk-order-message');

    /**
     * Recalculate all row subtotals and the grand total.
     */
    function recalculate() {
      var grandTotal = 0;
      var totalItems = 0;

      rows.forEach(function (row) {
        var input = row.querySelector('.bulk-qty-input');
        var subtotalEl = row.querySelector('.bulk-row-subtotal') || row.querySelector('.bulk-row-total');
        var price = parseInt(row.getAttribute('data-price'), 10) || 0;
        var qty = parseInt(input.value, 10) || 0;

        if (qty < 0) {
          qty = 0;
          input.value = 0;
        }

        var subtotal = price * qty;
        grandTotal += subtotal;
        totalItems += qty;

        if (subtotalEl) {
          subtotalEl.textContent = formatMoney(subtotal);
        }
      });

      if (totalEl) totalEl.textContent = formatMoney(grandTotal);
      if (itemsEl) {
        // Support both formats: just the number, or "X items"
        if (itemsEl.classList.contains('bulk-total-items')) {
          itemsEl.textContent = totalItems;
        } else {
          itemsEl.textContent = totalItems + (totalItems === 1 ? ' item' : ' items');
        }
      }

      if (addBtn) {
        if (totalItems > 0) {
          addBtn.disabled = false;
          addBtn.style.opacity = '1';
        } else {
          addBtn.disabled = true;
          addBtn.style.opacity = '0.5';
        }
      }
    }

    /**
     * Attach quantity +/- button handlers.
     */
    rows.forEach(function (row) {
      var input = row.querySelector('.bulk-qty-input');
      var minusBtn = row.querySelector('.bulk-qty-minus');
      var plusBtn = row.querySelector('.bulk-qty-plus');

      // Support new section markup (separate minus/plus classes)
      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 0;
          if (val > 0) input.value = val - 1;
          recalculate();
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 0;
          input.value = val + 1;
          recalculate();
        });
      }

      // Support legacy markup (data-action on .bulk-qty-btn)
      row.querySelectorAll('.bulk-qty-btn[data-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var action = btn.getAttribute('data-action');
          var val = parseInt(input.value, 10) || 0;
          if (action === 'increase') {
            input.value = val + 1;
          } else if (action === 'decrease' && val > 0) {
            input.value = val - 1;
          }
          recalculate();
        });
      });

      if (input) {
        input.addEventListener('change', recalculate);
        input.addEventListener('input', recalculate);
      }
    });

    /**
     * Add all items to cart via Shopify AJAX API (batch).
     */
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var items = [];

        rows.forEach(function (row) {
          var input = row.querySelector('.bulk-qty-input');
          var variantId = row.getAttribute('data-variant-id');
          var qty = parseInt(input.value, 10) || 0;

          if (qty > 0 && variantId) {
            items.push({
              id: parseInt(variantId, 10),
              quantity: qty
            });
          }
        });

        if (items.length === 0) return;

        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        addBtn.textContent = 'Adding to Cart...';
        addBtn.style.opacity = '0.7';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Failed to add items to cart');
            return response.json();
          })
          .then(function () {
            showMessage('success', 'All items added to cart successfully!');

            // Reset quantities
            rows.forEach(function (row) {
              var input = row.querySelector('.bulk-qty-input');
              if (input) input.value = 0;
            });
            recalculate();

            // Update cart count in header
            updateCartBubble();

            // Dispatch event for other theme scripts
            document.dispatchEvent(new CustomEvent('cart:updated'));

            addBtn.textContent = originalText;
            addBtn.style.opacity = '0.5';
          })
          .catch(function (error) {
            showMessage('error', 'There was an error adding items to your cart. Please try again.');
            addBtn.disabled = false;
            addBtn.textContent = originalText;
            addBtn.style.opacity = '1';
            console.error('Bulk order error:', error);
          });
      });
    }

    /**
     * Update cart bubble/count in the header.
     */
    function updateCartBubble() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var selectors = [
            '[data-cart-count]',
            '.cart-count',
            '.cart-bubble__count',
            '.cart-icon__count'
          ];
          selectors.forEach(function (sel) {
            document.querySelectorAll(sel).forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });
        })
        .catch(function () { /* silent */ });
    }

    /**
     * Show a success or error message below the form.
     */
    function showMessage(type, text) {
      if (!messageEl) {
        // Fallback for legacy markup: alert
        if (type === 'error') alert(text);
        return;
      }
      messageEl.style.display = 'block';
      messageEl.textContent = text;

      if (type === 'success') {
        messageEl.style.background = '#f0fdf4';
        messageEl.style.color = '#16a34a';
        messageEl.style.border = '1px solid #bbf7d0';
      } else {
        messageEl.style.background = '#fef2f2';
        messageEl.style.color = '#dc2626';
        messageEl.style.border = '1px solid #fecaca';
      }

      setTimeout(function () {
        messageEl.style.display = 'none';
      }, 5000);
    }

    // Initial calculation
    recalculate();
  }

  /* ========================================================================
   * RESOURCE HUB: Category Filter Tabs
   * Works with both new (.resource-tab) and legacy (.resource-filter-btn) selectors
   * ======================================================================== */

  function initResourceHub() {
    var tabs = document.querySelectorAll('.resource-tab, .resource-filter-btn');
    var cards = document.querySelectorAll('.resource-card');

    if (tabs.length === 0 || cards.length === 0) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var category = this.getAttribute('data-category');

        // Update active tab styling
        tabs.forEach(function (t) {
          t.classList.remove('active');
          // Reset inline styles for new section tabs
          if (t.classList.contains('resource-tab')) {
            t.style.color = '#1B4D6E';
            t.style.background = '#FFFFFF';
            t.style.borderColor = '#E5E2DD';
          }
        });

        this.classList.add('active');
        if (this.classList.contains('resource-tab')) {
          this.style.color = '#FFFFFF';
          this.style.background = '#1B4D6E';
          this.style.borderColor = '#1B4D6E';
        }

        // Filter cards with fade animation
        cards.forEach(function (card) {
          if (category === 'all' || card.getAttribute('data-category') === category) {
            card.style.display = '';
            card.style.opacity = '0';
            requestAnimationFrame(function () {
              card.style.transition = 'opacity 0.3s ease';
              card.style.opacity = '1';
            });
          } else {
            card.style.opacity = '0';
            setTimeout(function () {
              card.style.display = 'none';
            }, 300);
          }
        });
      });
    });
  }

  /* ========================================================================
   * PROFESSIONAL PRICING TOGGLE
   * Supports both data-attribute toggles and class-based toggles
   * ======================================================================== */

  function initPricingToggle() {
    // New section: data-pricing-toggle buttons
    var toggleBtns = document.querySelectorAll('[data-pricing-toggle]');
    toggleBtns.forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var target = this.getAttribute('data-pricing-toggle');
        var proPrices = document.querySelectorAll('.dual-pricing--pro');
        var retailPrices = document.querySelectorAll('.dual-pricing--retail');

        if (target === 'retail') {
          proPrices.forEach(function (el) { el.style.display = 'none'; });
          retailPrices.forEach(function (el) { el.style.display = ''; });
        } else {
          proPrices.forEach(function (el) { el.style.display = ''; });
          retailPrices.forEach(function (el) { el.style.display = 'none'; });
        }
      });
    });

    // Legacy: checkbox toggle (.pricing-toggle-switch)
    var legacyToggle = document.querySelector('.pricing-toggle-switch');
    if (legacyToggle) {
      legacyToggle.addEventListener('change', function () {
        var showPro = legacyToggle.checked;
        document.querySelectorAll('.dual-pricing').forEach(function (el) {
          if (showPro) {
            el.classList.add('show-pro');
          } else {
            el.classList.remove('show-pro');
          }
        });
      });
    }
  }

  /* ========================================================================
   * PROFESSIONAL DASHBOARD TABS (legacy support)
   * ======================================================================== */

  function initDashboardTabs() {
    var container = document.querySelector('.skymedic-pro-dashboard');
    if (!container) return;

    var tabs = container.querySelectorAll('.dashboard-tab');
    var panels = container.querySelectorAll('.dashboard-panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        panels.forEach(function (p) { p.classList.remove('active'); });
        tab.classList.add('active');
        var panelId = tab.getAttribute('data-panel');
        var panel = container.querySelector('#' + panelId);
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* ========================================================================
   * PROFESSIONAL VISIBILITY
   * Show/hide elements based on customer's professional status.
   * Uses a data attribute set by Liquid in the theme:
   *   <body data-customer-pro="true">
   * Elements with [data-pro-only] are hidden for non-professional customers.
   * Elements with [data-retail-only] are hidden for professional customers.
   * ======================================================================== */

  function initProVisibility() {
    /* If B2B disabled (BR market), treat everyone as a regular consumer:
     * — Hide [data-pro-only] elements (no PRO-only content shown)
     * — Show [data-retail-only] elements (everyone sees retail UI)
     */
    var b2bDisabled = document.body.getAttribute('data-customer-b2b-disabled') === 'true';
    var isPro = !b2bDisabled && document.body.getAttribute('data-customer-pro') === 'true';

    document.querySelectorAll('[data-pro-only]').forEach(function (el) {
      el.style.display = (isPro && !b2bDisabled) ? '' : 'none';
    });
    document.querySelectorAll('[data-retail-only]').forEach(function (el) {
      el.style.display = (isPro && !b2bDisabled) ? 'none' : '';
    });
  }

  /* ========================================================================
   * INIT: Run on DOM ready
   * ======================================================================== */

  function init() {
    initBulkOrderForm();
    initResourceHub();
    initPricingToggle();
    initDashboardTabs();
    initProVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
